module.exports = __webpack_public_path__ + "static/media/steve.e176d5e0.jpg";